export default "__VITE_ASSET__ac7660da__"